import { useState } from "react";

const ARTIFACTS = [
  { id: "gold", item: "金帛", target: "封入箱中", symbol: "金" },
  { id: "seal", item: "官印", target: "挂回梁上", symbol: "印" },
  { id: "letter", item: "书信", target: "置于案前", symbol: "书" },
] as const;

interface ArtifactPlacementProps {
  placed: string[];
  onPlaced: (ids: string[]) => void;
}

export function ArtifactPlacement({ placed, onPlaced }: ArtifactPlacementProps) {
  const [selected, setSelected] = useState<string>("");

  const place = (id: string, targetId: string) => {
    if (id !== targetId || placed.includes(id)) return;
    onPlaced([...placed, id]);
    setSelected("");
  };

  return (
    <div className="artifact-puzzle" aria-label="封金挂印拖放互动">
      <div className="artifact-items" aria-label="待放置物件">
        {ARTIFACTS.map((artifact) => (
          <button
            type="button"
            key={artifact.id}
            className={`artifact ${selected === artifact.id ? "is-selected" : ""}`}
            disabled={placed.includes(artifact.id)}
            draggable={!placed.includes(artifact.id)}
            onDragStart={(event) => event.dataTransfer.setData("text/plain", artifact.id)}
            onClick={() => setSelected(artifact.id)}
            aria-pressed={selected === artifact.id}
          >
            <span>{artifact.symbol}</span>
            {placed.includes(artifact.id) ? `${artifact.item}已归位` : artifact.item}
          </button>
        ))}
      </div>
      <div className="artifact-targets">
        {ARTIFACTS.map((artifact) => (
          <button
            type="button"
            key={artifact.id}
            className={`artifact-target ${placed.includes(artifact.id) ? "is-filled" : ""}`}
            onDragOver={(event) => event.preventDefault()}
            onDrop={(event) => place(event.dataTransfer.getData("text/plain"), artifact.id)}
            onClick={() => selected && place(selected, artifact.id)}
            disabled={placed.includes(artifact.id)}
          >
            {placed.includes(artifact.id) ? `已${artifact.target}` : artifact.target}
          </button>
        ))}
      </div>
      <p className="microcopy">拖动物件，或先点物件再点位置。</p>
    </div>
  );
}
